import './scss/index.scss'
import BPlayer from './core/Player'

export default BPlayer